import { AlkLogger } from '@alk/core';
import { comApiConnexionWaitingDelay } from '../../../../constants';
import { healthCheck } from '../worker-channel-hub.utils';
export const getMessageSystemTypeClientHandler = (messageSystem) => {
    return {
        ['healthCheck']: healthCheckSystemClientHandler(messageSystem),
        ['notification']: notificationSystemClientHandler(messageSystem),
        ['channelSubscriptionResponse']: channelSubscriptionSystemClientHandler(messageSystem),
        ['channelUnsubscriptionResponse']: channelUnsubscriptionSystemClientHandler(messageSystem),
        ['ready']: readyClientHandler(),
    }[messageSystem.type];
};
export const healthCheckSystemClientHandler = (messageSystem) => async (workerChannelHub) => {
    AlkLogger.debug(messageSystem);
    if (messageSystem.message === 'checking') {
        await workerChannelHub.systemDispatch('healthCheck', 'alive');
    }
    if (messageSystem.message === 'alive') {
        await healthCheck(workerChannelHub, messageSystem.id, comApiConnexionWaitingDelay);
    }
};
export const notificationSystemClientHandler = (messageSystem) => async () => {
    AlkLogger.debug('no implemented yet', messageSystem);
};
export const channelUnsubscriptionSystemClientHandler = (messageSystem) => async (workerChannelHub) => {
    workerChannelHub.channels.get(messageSystem.message).triggerDisconnection();
};
export const channelSubscriptionSystemClientHandler = (messageSystem) => async (workerChannelHub) => {
    workerChannelHub.channels.get(messageSystem.message).triggerConnection();
};
export const readyClientHandler = () => async (workerChannelHub) => {
    workerChannelHub.ready = true;
    healthCheck(workerChannelHub, null, comApiConnexionWaitingDelay);
};
